import "core-js/stable";
import "regenerator-runtime/runtime";
import "ion-rangeslider";
import "jquery";
import "jquery-zoom";
import "hammerjs";
import { tns } from "tiny-slider/src/tiny-slider";
window.tns = tns;

import {} from "./theme/accordion.js";
import {} from "./theme/compact-search.js";
import {} from "./theme/dropdown.js";
import {} from "./theme/nav.js";
import {} from "./theme/price-slider.js";
import {} from "./theme/product-comparison.js";
import {} from "./theme/product-images.js";
import {} from "./theme/product-gallery.js";
import {} from "./theme/product-variants.js";
import {} from "./theme/slideshow.js";
import {} from "./theme/tabs.js";
import {} from "./theme/toggle-active.js";
import {} from "./theme/toggle-required.js";
import {} from "./theme/live-filters.js";
import {} from "./theme/date.js";

window.currencyFormat = function (elem) {
  var inputVal = $(elem).val();
  var convertedVal = parseFloat(inputVal).toFixed(2);
  $(elem).val(convertedVal);
}

window.setToDate = function(elem) {
  var fromVal = $(elem).val();
  $('input#to_date').attr("min", fromVal)
}

window.upCase = function (elem) {
  var inputVal = $(elem).val();
  var convertedVal = inputVal.toUpperCase();
  $(elem).val(convertedVal);
}

var spinnerRequests = [];

window.spinnerStart = function(keydown) {
  var currentId = new Date().getTime();
  spinnerRequests.push(currentId);
  $('.spinner_container').addClass('active').off('keydown');
  if (typeof keydown === 'function') {
    $(document).off('keydown.spinner_container').on('keydown.spinner_container', function (event) {
      if (event.key === 'Escape') {
        keydown();
        console.log('User stops the process by pressing ESC.')
        spinnerStop(currentId);
      }
    });
  }
  return currentId;
}

window.spinnerStop = function(currentId) {
  spinnerRequests.splice(spinnerRequests.indexOf(currentId), 1);
  if (spinnerRequests.length == 0) {
    $('.spinner_container').removeClass('active');
  }
}

window.talendCheck = function(element, url, ajaxOptions, options) {
  options = options || {};
  // console.log(options);
  // console.log(options.errorText);
  ajaxOptions = ajaxOptions || {};

  var retry = 0;
  var $element = $(element);
  var $errorElement = $(options.errorElement || '.Alert');
  var retryCount = options.retryCount || 600;
  var interval = options.interval || 1000;
  var errorText = options.errorText || 'Could not connect to the server.';
  var reset = options.reset || function () { $element.html(''); $errorElement.html('') };
  var callback = options.callback || function (data) { $element.html(data) };
  var skip = options.skip;

  var currentTimeoutId;
  var spinnerId = spinnerStart(function () {
    clearTimeout(currentTimeoutId);
  });

  ajaxOptions.url = url;
  ajaxOptions.type = ajaxOptions.type || 'GET';
  ajaxOptions.cache = false;

  reset();
  var checkForResult = function () {
    $.ajax(ajaxOptions).done(function (data, textStatus, jqXHR) {
      if (jqXHR.status == 204) {
        if (++retry < retryCount) {
          currentTimeoutId = setTimeout(checkForResult, interval);
        } else {
          spinnerStop(spinnerId);
          $errorElement.html("The server took too long to generate the results, try changing or reducing your selection and try again.");
        }
      } else {
        if (!skip) { spinnerStop(spinnerId); }
        callback(data, spinnerId);
      }
    }).fail(function (error) {
      spinnerStop(spinnerId);
      $errorElement.html(errorText);
    });
  }

  currentTimeoutId = setTimeout(checkForResult, interval);
}

window.check_all = function(namespace) {
  namespace = namespace || '';
  $(document).off('change' + namespace + ':all_checkbox').on('change' + namespace + ':all_checkbox', ':checkbox.all', function () {
    var now = $(this).prop('checked'),
      $form = $(this).parents('form');
    $(this).prop('checked', now);
    $(':checkbox:not(.all)', $form).prop('checked', now)
  });

  $(document).off('change' + namespace + ':checkbox').on('change' + namespace + ':checkbox', ':checkbox:not(.all)', function () {
    var $form = $(this).parents('form');
    $(':checkbox.all', $form).prop('checked', $(':checkbox:not(.all)').map(function () {
      return $(this).prop('checked');
    }).toArray().every(function (condition) { return condition; }));
  });

  $(document).find(':checkbox:not(.all):first').trigger('change' + namespace + ':checkbox');
}

window.initMap = function () {
  var myLatLng = {lat: -25.363, lng: 131.044};

  var map = new google.maps.Map(document.getElementById("js-map"), {
    zoom: 4,
    streetViewControl: false,
    center: myLatLng
  });
}
